import Backdrop from "@mui/material/Backdrop";
import loader from "../../../assets/images/loader.gif";
import { appLoaderStyles } from "./useStyles";

// used for showing APP Loading
export default function AppLoader() {
  return (
    <Backdrop
      id="loaderContainer"
      sx={appLoaderStyles.backdrop}
      open={true}
      onClick={() => null}
    >
      <img alt="logo" src={loader}></img>
    </Backdrop>
  );
}
